// функция для перебора итераторов, с возможностью ограничения количества итераций
export const forIterator = <T>(
    iterator: Iterable<T>,
    callback: (item: T, index: number, iterator: Iterable<T>) => void,
    size?: number
) => {
    if (size === undefined) {
        size = Infinity;
    }
    if (size <= 0) {
        return;
    }
    let index = 0;

    for (const item of iterator) {
        callback(item, index, iterator);
        index++;
        if (index === size) {
            return;
        }
    }
};
